import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const ifThenPdf = pdfFiles.strategiesPart2.find(
  (pdf) => pdf.name === 'Examples of If/Then & When/Then Statements',
);

const WhenThenStatements = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter pdfFile={ifThenPdf} vidSrc={1194425987} />
    </div>
  );
};

export default WhenThenStatements;
